import { z } from 'zod';
/** Sévérité d'un événement — `03` §2 (`events.severity`) et `01` §9.1. */
export const EVENT_SEVERITIES = ['info', 'warning', 'critical'];
export const eventSeveritySchema = z.enum(EVENT_SEVERITIES);
export const EVENT_SEVERITY = {
    info: { code: 'info', label: 'Info', tone: 'gray' },
    warning: { code: 'warning', label: 'Avertissement', tone: 'orange' },
    critical: { code: 'critical', label: 'Critique', tone: 'red' },
};
/** Type d'objet visé par un événement — `03` §2 (`events.subject.type`). */
export const EVENT_SUBJECT_TYPES = [
    'order',
    'file',
    'run',
    'invoice',
    'store',
    'system',
];
export const eventSubjectTypeSchema = z.enum(EVENT_SUBJECT_TYPES);
/** Statut d'expédition d'une alerte — `03` §2 (`events.alert`). */
export const ALERT_DELIVERY_STATUSES = ['sent', 'grouped', 'failed'];
export const alertDeliveryStatusSchema = z.enum(ALERT_DELIVERY_STATUSES);
export const ALERT_DELIVERY_STATUS = {
    sent: { code: 'sent', label: 'Envoyée', tone: 'green' },
    grouped: { code: 'grouped', label: 'Regroupée', tone: 'blue' },
    failed: { code: 'failed', label: 'Échec', tone: 'red' },
};
//# sourceMappingURL=severity.js.map